import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from 'kea-resource';
import { PrecioPaquetePP, Session } from 'app/models/requireme';


const controller = rpcController("PaquetePP");
const controller2 = rpcController("Login");

export const PaquetePP = cacheResource({
    /**Obtiene el rastreo de una guia dado su folio */
    Query: async (filtro: models.PaquetePPFiltro): Promise<models.PaquetePPDto[]> => await controller('Query', {}, filtro),

    AgregarPaquetePP: async (model: models.NuevoPaquetePPModel): Promise<models.PaquetePPFactura> => await controller('AgregarPaquetePP', {}, model),
    ObtenerPrecioPaquete: async (model: models.DatosPaquetePPModel): Promise<PrecioPaquetePP> => await controller('ObtenerPrecioPaquete', {}, model),
    Get: async (id: number): Promise<models.PaquetePPDto> => await controller("Get", { id }),

    /**Genera una factura a partir de un paquete de PP. Devuelve el Id de la factura */
    FacturarPaquetePP: async (id: number): Promise<number> => await controller("FacturarPaquetePP", { id }),

    /**Factura y timbra un paquete de PP. Devuelve el Id de la factura */
    FacturarTimbrarPaquetePP: async (id: number): Promise<number> => await controller("FacturarTimbrarPaquetePP", { id }),

    /**Obtiene un listado de guías de PP */
    QueryGuiasPP: async (filtro: models.GuiaPPFiltro) => await controller("QueryGuiasPP", {}, filtro),

    GetSession: async (): Promise<Session> => await controller2("GetSession",{}),

    QueryGuiasPPSelectorTarifa: async (filtro: models.GuiaPPFiltro) : Promise<models.ItemsSelectorTarifasPP[]> => await controller("QueryGuiasPPSelectorTarifa", {}, filtro),

    /**Devuelve el PDF de la impresión las guias de PP */
    ImprimirGuias: async (idPaquetePP: number, folio: string): Promise<string> => await controller("ImprimirGuias", { idPaquetePP, folio }),

    /**Devuelve el excel del reporte de venta de PP */
    ReporteVentaPP: async (filtro: models.ReporteVentaPPParametros): Promise<string> => await controller("ReporteVentaPP", {}, filtro),

    /**Devuelve el Excel con el reporte de paquetes de PP */
    ReportePaquetesPP: async (filtro: models.ReportePaquetesPPParametros): Promise<string> => await controller("ReportePaquetesPP", {}, filtro),

    /**Cancela todas las guías de un paquete PP */
    CancelarGuias: async (idPaquete: number): Promise<string[]> => await controller("CancelarGuias", {idPaquete}),

    PagarPaquetePP: async (idPaquete: number): Promise<boolean> => await controller("PagarPaquetePP", {idPaquete}),

    CancelarPaquetePP: async (idPaquete: number): Promise<number[]> => await controller("CancelarPaquetePP", {idPaquete}),

}, {}, {});




// WEBPACK FOOTER //
// ./app/resources/items/paquetespp.ts